var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('service',{staticClass:"bs-5"})],1),_c('div',{staticClass:"col-md-6"},[_c('industry',{staticClass:"bs-5"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }